import { ImgHTMLAttributes } from "react";
import { IMAGE_POSTFIX_MOBILECARD, IMAGE_POSTFIX_WEBCARD, IMAGE_POSTFIX_WEBFULL } from "commonModule/globalConstant";
import ProgressiveImage from "components/utilities/ProgressiveImage";
type Props = {
  src: string;
  postfix?: typeof IMAGE_POSTFIX_WEBCARD | typeof IMAGE_POSTFIX_MOBILECARD | typeof IMAGE_POSTFIX_WEBFULL;
};
const DetailPageImage = (props: ImgHTMLAttributes<HTMLImageElement> & Props) => {
  const {
    src,
    alt = "vacation rental property image",
    className = "",
    postfix = IMAGE_POSTFIX_WEBCARD,
    ...rest
  } = props;
  return <ProgressiveImage src={src || ""} alt={alt} postfix={postfix} {...rest} className={`h-full w-full overflow-hidden bg-gray-200 object-cover text-transparent ${className}`} data-sentry-element="ProgressiveImage" data-sentry-component="DetailPageImage" data-sentry-source-file="DetailPageImage.tsx" />;
};
export default DetailPageImage;